import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, filter, from, iif, of, switchMap, throwError } from 'rxjs';
import { jwtDecode } from "jwt-decode";

//services
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { TokenService } from './token.service';
import { DecodedToken } from './decodedToken';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  // api de autenticacao
  //private url = 'https://splitpayauthenticator.azurewebsites.net/Jwt/token';

  private response: any = {};

  constructor(private http: HttpClient,  private tokenService: TokenService) {}

  // post de autenticacao
  public authPOST(payLoad: {
    email: string;
    password: string;
    unitId?: string;
  }): Observable<any> {
    let options = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/ld+json'
      )
    };

    return this.http.post<any>(`${environment.enma_url}/login`, payLoad, options);
  }
  public authRefreshPOST(payLoad: {
    userId: number;
    unitId: number;
    refreshToken: string;
  }): Observable<any> {
    return this.http.post<any>(`${environment.enma_url}/refresh`, payLoad);
  }
   // post de autenticacao
  public authResetPOST(payLoad: {
    username: string;
    email: string;
  }): Observable<any> {
    /*
    const body = new URLSearchParams();
    body.set('client_id', 'splitpaybrazil');
    body.set('username', payLoad.username);
    body.set('email', payLoad.email);

    let options = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/x-www-form-urlencoded'
      ).set(
        'Authorization',
        `Basic ${btoa('splitpaybrazil:3QMENK63PhG3E2I5NtKWB4otS3V56RjY')}`
      ) 
    };
    return this.http.post<any>(this.urlReset, body.toString(), options)
   */
    return of([]);
  }

  // funcao chamada quando o usuario clicla em lembrar-me
  public rememberUser() {
    localStorage.removeItem('access_token');
    localStorage.setItem('access_token', this.response.token);
  }

  //funcao que confere a autenticidade do login
  public isAuthenticated(): Observable<boolean> {
    const token = localStorage.getItem('access_token');
    const userId = Number.parseInt(<string>localStorage.getItem('userId'));
    const unitId = Number.parseInt(<string><string>localStorage.getItem('unitId'));
    const jwtHelper = new JwtHelperService();

    return of(jwtHelper.isTokenExpired(token)).pipe(
      switchMap((tokenExpired) => {
        if(tokenExpired) {
          return this.authRefreshPOST({
            userId: userId,
            unitId: unitId,
            refreshToken: this.tokenService.getRefreshToken()
          }).pipe(
            switchMap((response: any) => {
              localStorage.setItem('access_token', response.accessToken);
              localStorage.setItem('refresh_token', response.refreshToken);
              return of(true);
            }),
            catchError(() => {
              localStorage.removeItem('access_token');
              return of(false);
            })
          )
        } else {
          return of(true);
        }
      })
    )

    /*if (token) {
      if (jwtHelper.isTokenExpired(token)) {
        const userId = <string>localStorage.getItem('userId');
        const unitId = <string>localStorage.getItem('unitId');
        this.authRefreshPOST({
          userId: Number.parseInt(userId),
          unitId: Number.parseInt(userId),
          refreshToken: this.tokenService.getRefreshToken()
        }).subscribe(
          {
            next: (response: any) => {
              localStorage.setItem('access_token', response.accessToken);
              localStorage.setItem('refresh_token', response.refreshToken);
            },
            error: (erro: any) => {
              localStorage.removeItem('access_token');
            },
          } 
        );

        return false;
      } else {
        return true;
      }
    } else if (this.response) {
      if (jwtHelper.isTokenExpired(this.response.token)) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }*/
  }

  // chamada quando o usuario clica em sair
  public logOut() {
    this.http.post(`${environment.enma_url}/logout`, {
        userId: Number(this.userId),
        unitId: Number(this.decodedToken().azp),
        refreshToken: this.tokenService.getRefreshToken()
    }).subscribe((response) => {
      localStorage.removeItem('access_token');
      this.response = {}; 
    });
    
    return true;
  }

  public decodedToken(): DecodedToken {
    const token = this.tokenService.getToken()
    let decodedToken = undefined
    if (token) {
      decodedToken = jwtDecode(token);
    }
    return <DecodedToken>decodedToken;
  }

  public get userId() : string {
    return <string>localStorage.getItem('userId');
  }
  public get unitId() : string {
    return <string>this.decodedToken().azp;
  }
}
